module.exports = "h3,\nh4,\nh5 {\n  margin: 0;\n}\n.card .desc {\n  font-size: 0.875em;\n  color: #555;\n  text-align: justify;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/special/shaman-spells/shaman-spells.component.less
// module id = ./src/app/special/shaman-spells/shaman-spells.component.less
// module chunks = main